import {
    GET_DISCOUNTS_REQUEST,
    GET_DISCOUNTS_SUCCESS,
    GET_DISCOUNTS_FAIL,
    CREATE_DISCOUNT_REQUEST,
    CREATE_DISCOUNT_SUCCESS,
    CREATE_DISCOUNT_FAIL,
    UPDATE_DISCOUNT_REQUEST,
    UPDATE_DISCOUNT_SUCCESS,
    UPDATE_DISCOUNT_FAIL,
    DELETE_DISCOUNT_REQUEST,
    DELETE_DISCOUNT_SUCCESS,
    DELETE_DISCOUNT_FAIL,
  } from '../actions/types';
  
  const initialState = {
    discounts: [],
    loading: false,
    error: null,
  };
  
  const discountReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_DISCOUNTS_REQUEST:
      case CREATE_DISCOUNT_REQUEST:
      case UPDATE_DISCOUNT_REQUEST:
      case DELETE_DISCOUNT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case GET_DISCOUNTS_SUCCESS:
        return { 
          ...state, 
          loading: false, 
          discounts: Array.isArray(action.payload) ? action.payload : []

        };
  
      case CREATE_DISCOUNT_SUCCESS:
        return {
          ...state,
          loading: false,
          discounts: [...state.discounts, action.payload],
          error: null,
        };
  
      case UPDATE_DISCOUNT_SUCCESS:
        return {
          ...state,
          loading: false,
          discounts: state.discounts.map(discount =>
            discount.id === action.payload.id ? action.payload : discount
          ),
          error: null,
        };
  
      case DELETE_DISCOUNT_SUCCESS:
        return {
          ...state,
          loading: false,
          discounts: state.discounts.filter(discount => discount.id !== action.payload),
          error: null,
        };
  
      case GET_DISCOUNTS_FAIL:
      case CREATE_DISCOUNT_FAIL:
      case UPDATE_DISCOUNT_FAIL:
      case DELETE_DISCOUNT_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default discountReducer;